var ctVacationModel;
(function ($) {
 	$.fn.capitechVacation = function() {
		var $ctVacationElm = $(this);
		var options = {};
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			options = { 
				extend: {
					"{root}.vacation[i]": function(vacation){
						vacation.translatedStatus = ko.computed(function() {
							var vacationDate = moment(vacation.date()).toDate();
							var currentDate = new Date();
							
							// Avviklet
							if (vacationDate < currentDate) {
								return getResource('vacation.statusDiscontinued', 'Avviklet');
							} else {
								return getResource('vacation.statusPlanned', 'Planlagt');
							}
						}, vacation);
					}
				}
			}
			getVacation();
		}
		
		function getVacation() {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					modelData.vacation = data.content;
					ctVacationModel = ko.viewmodel.fromModel(modelData, options);
					$('*[data-ko-bind="ctVacationModel"]').each(function(index, obj) {
						ko.applyBindings(ctVacationModel, obj);
					});
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.getVacationTransactions_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME));
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));